import { ElementsFactories } from 'react-planner';

const info = {
  title: 'U Shape',
  tag: ['shape'],
  description: 'U Shape',
  image: require('./area-u-shape.png')
};

export default ElementsFactories.AreaFactory('area-u', info);
